<template>
<div>
<b-modal id="confirmSaveModal" hide-footer v-bind:title="$t('title')" centered>
  <div class="d-block">
    <!--<h3>{{$t('title')}}!</h3>-->
    <p>
      {{$t('confirmText')}}
    </p>
  </div>
  <div class="row">
    <div class="col-6">
      <b-button class="mt-3" block @click="$bvModal.hide('confirmSaveModal')">
        {{$t('cancel')}}
      </b-button>
    </div>
    <div class="col-6">
      <b-button class="mt-3 btn-primary" block @click="confirm">
        {{$t('save')}}
      </b-button>
    </div>
  </div>
</b-modal>
</div>
</template>

<script>

export default {
  name: 'ConfirmSave',
  props: ['saveImage'],
  methods: {
    confirm(){
      this.$bvModal.hide('confirmSaveModal');
      this.saveImage();
    }
  }
}
</script>

<i18n>
{
  "en": {
    "title": "Save Image?",
    "confirm": "Do you want to save image for later transcription?",
    "cancel": "Cancel",
    "save": "Save"
  },
  "sl": {
    "title": "Shrani sliko?",
    "confirmText": "Ali želite shraniti sliko za kasnejši prepis?",
    "cancel": "Prekliči",
    "save": "Shrani"
  }
}
</i18n>
